<template>
    <div class="c_connect_room">
        <div class="roomDetailModel-bg" @click="close"></div>
        <div class="roomDetailModel-container">
            <div class="roomDetailModel-title">
                <img src="https://resource.rcclchina.com.cn/cruiseDetail/mb_connect_type.png">
                <span>请选择房间类型</span>
            </div>
            <div class="roomDetailModel-con">
                <div class="room_double" :class="{ active: this.connectGuestCount == '2,2'}" @click="connectGuestSelected('2,2')">
                    <div :class="{c_room_outOfStock:isOutOfStock}">
                      双人房&nbsp;+&nbsp;双人房 (组合)<span>售罄</span>
                      <img src="https://resource.rcclchina.com.cn/cruiseDetail/mb_con_gou.png" alt="">
                    </div>
                </div>
                <div class="room_double" :class="{ active: this.connectGuestCount == '2,3'}" @click="connectGuestSelected('2,3')">
                    <div :class="{c_room_outOfStock:isOutOfStock}">
                      双人房&nbsp;+&nbsp;三人房 (组合) <span>售罄</span>
                      <img src="https://resource.rcclchina.com.cn/cruiseDetail/mb_con_gou.png" alt="">
                    </div>
                </div>
                <img @click="onShowConnectRoomPopup()" class="c_con_what" src="https://resource.rcclchina.com.cn/cruiseDetail/mb_con_what.png" alt="">
            </div>
            <div class="roomDetailModel-closed c_js_closedBtn" @click="close"><span>X</span></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectConnectStateroom',
    props: {
        connectGuestCount: {
            type: String,
            default () {
                return ''
            }
        },
        onConnectClose: {
            type: Function
        },
        onConnectGuestSelected: {
            type: Function
        },
        showConnectRoomPopup: {
            type: Function
        },
        isOutOfStock:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        connectGuestSelected (connectGuestCount) {
            this.onConnectGuestSelected(connectGuestCount)
        },
        close () {
            this.onConnectClose()
        },
        onShowConnectRoomPopup () {
            this.showConnectRoomPopup()
        }
    }
}
</script>

<style lang="less" scoped>
.c_connect_room {
    display: block;
    width: 100%;
    // background-color: rgba(0,0,0,.4);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0px;
    z-index: 10399;
    
    .roomDetailModel-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
        position: absolute;
        top: 0;
        left: 0;
    }
    .roomDetailModel-container {
        background-color: #fff;
        border-top: 5px solid #FEBC10;
        padding: 22px 20px 13px 20px;
        position: absolute;
        width: 100%;
        bottom: 0px;
        
        padding-bottom: 46px;
        .roomDetailModel-title {
            padding-bottom: 8px;
            margin-bottom: 12px;
            img {
                width: 22px;
                vertical-align: middle;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                
                font-size: 14px;
                color: #4A90E2;
                letter-spacing: 1px;
                margin-left: 5px;
            }
        }
        .roomDetailModel-con {
            margin-top: 12px;
            .room_double {
                font-size: 14px;
                color: #333;
                letter-spacing: 1px;
                line-height: 76px;
                border-bottom: 1px solid #e5e5e5;
                font-weight: 500;
                img {
                    width: 16px;
                    margin-left: 9px;
                    vertical-align: middle;
                    display: none;
                }
              span{
                display: none;
              }
            }
            .room_double.active {
                color: #4A90E2;
                img {
                    display: inline-block;
                }
            }
          .active .c_room_outOfStock{
            color: #ABABAB;
            img{
              display: none;
            }
            span{
              display: inline-block;
            }
          }
            .room_double:last-of-type {
                margin-bottom: 20px;
            }
            .c_con_what {
                width: 200px;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
            }
        }

        .roomDetailModel-closed {
            width: 38px;
            text-align: center;
            height: 34px;
            line-height: 34px;
            position: absolute;
            top: -4px;
            right: -4px;
            background: #FEBC10;
            border-bottom-left-radius: 8px;
            -webkit-border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            -webkit-border-bottom-right-radius: 8px;
            > span {
                display: inline-block;
                color: #fff;
                font-size: 16px;
                -webkit-transform: scale(1.5,1.3);
                -moz-transform: scale(1.5,1.3);
                -ms-transform: scale(1.5,1.3);
                -o-transform: scale(1.5,1.3);
                transform: scale(1.5,1.3);
            }
        }
    }
}
</style>